import React from 'react'
import type { UpsellPlanId } from 'src/lib/types/appsIntegrations'
import { classNames } from '../helpers'

interface PlanBadgeProps {
  plan: UpsellPlanId
  className?: string
}

const PLAN_BADGE_CONFIG: Record<UpsellPlanId, { label: string; containerClassName: string; textClassName: string }> = {
  lite: {
    label: 'Lite',
    containerClassName: 'w-[38px] shrink-0 bg-gradient-to-b from-sky-50 to-sky-200',
    textClassName: 'text-sky-900'
  },
  plus: {
    label: '+Plus',
    containerClassName: 'bg-gradient-to-b from-purple-50 to-[#E2C4FF]',
    textClassName: 'text-purple-900'
  }
}

export const PlanBadge: React.FC<PlanBadgeProps> = ({ plan, className }) => {
  const { label, containerClassName, textClassName } = PLAN_BADGE_CONFIG[plan]

  return (
    <span
      className={classNames(
        'inline-flex h-5 items-center justify-center gap-2 rounded-[31px] px-1 py-0.5 shadow-[0_1px_2px_0_rgba(10,13,18,0.05)]',
        containerClassName,
        className ?? ''
      )}
    >
      <span className={classNames('text-text-sm-semibold italic', textClassName)}>{label}</span>
    </span>
  )
}
